import { createApp } from "vue";
import { createPinia } from "pinia";
import moment from 'moment';

import App from "./App.vue";
import store from "./store";
import router from "./router";
import "./assets/css/nucleo-icons.css";
import "./assets/css/nucleo-svg.css";
import "./assets/fontawesome/css/all.min.css";
import VueTilt from "vue-tilt.js";
import {globalMixin} from './assets/js/global-functions';
import clickOutside from './assets/js/click-outside';
import { tooltip } from './assets/js/tooltip.js';
import ArgonDashboard from "./argon-dashboard.js";
import { openConfirmDialog } from "@/components/modal/confirmDialogService";
moment.locale('es');

const appInstance = createApp(App);
const pinia = createPinia();
appInstance.directive("click-outside", clickOutside);
appInstance.directive('tooltip', tooltip);

appInstance.mixin(globalMixin);
appInstance.use(store);
appInstance.use(pinia);
appInstance.use(router);
appInstance.use(VueTilt);
appInstance.config.globalProperties.$swal = openConfirmDialog;
appInstance.provide("$swal", openConfirmDialog);
appInstance.mount("#app");
appInstance.use(ArgonDashboard);
